import React, { useContext } from 'react'
import { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './ProfileEdit.module.sass'
import Control from '../../components/Control'
import TextInput from '../../components/TextInput'
import TextArea from '../../components/TextArea'
import Icon from '../../components/Icon'
import { get, post, randomAvatar } from '../../adapters/api'
import { Web3Context } from '../../contexts/Web3Context'
import { Button, message, Upload } from 'antd'
import SwitchNetwork from '../../components/ConnectMetamask/SwitchNetwork'
import Connect from '../../components/Connect'
import Loader from '../../components/Loader'

message.config({ top: 100, duration: 5, maxCount: 3 })

const breadcrumbs = [
  {
    title: 'Home',
    url: '/',
  },
  {
    title: 'Edit Profile',
  },
]

export default function ProfileEdit () {

  const [avatar, setAvatar] = useState('/images/content/avatar-3.jpg')
  const [username, setUsername] = useState('')
  const [link, setLink] = useState('')
  const [description, setDescription] = useState('')
  const [insta, setInsta] = useState('')
  const [tweet, setTweet] = useState('')
  const [showLoader, setShowLoader] = useState(false)

  const { defaultAccount, signMgs, isConnected, isCorrectNetwork } = useContext(Web3Context)

  useEffect(() => {
    (async () => {
      if (!defaultAccount) {
        window.location.href = '/'
      }

      const profile = await get('user/profile?from=' + defaultAccount)
      if (profile.data) {
        if (profile.data.avatar) {
          setAvatar(profile.data.avatar)
        } else {
          const ava = await randomAvatar()
          setAvatar(ava.data)
        }
        if (profile.data.username) {
          setUsername(profile.data.username)
        }
        if (profile.data.link) {
          setLink(profile.data.link)
        }
        if (profile.data.description) {
          setDescription(profile.data.description)
        }
        if (profile.data.insta) {
          setInsta(profile.data.insta)
        }
        if (profile.data.tweet) {
          setTweet(profile.data.tweet)
        }
      }
    })()
  }, [defaultAccount])

  const updateProfile = async (event) => {
    event.preventDefault()

    setShowLoader(true)

    try {
      const sign = await signMgs({ avatar: avatar.slice(-10), username, link, description, insta, tweet })

      if (!sign) {
        message.error('Error on change profile')
        setShowLoader(false)
        return false
      }

      const result = await post('user/profile', { from: defaultAccount, sign, avatar, username, link, description, insta, tweet })

      if (result) {
        message.success('Profile will be changes soon')
        setShowLoader(false)
        window.location.href = '/profile'
      }
    } catch (e) {
      console.error(e)
      message.error('Error on change profile')
      setShowLoader(false)
      return false
    }
  }

  const prepareFile = async (file) => {
    return await new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
    })
  }

  const handleUploadAvatar = async info => {
    const fileData = await prepareFile(info)
    setAvatar(fileData)

    return false
  }

  const handleUsername = (event) => {
    const username = event.target.value
    //todo:
    // if (username.length > 64) {
    //     setOwnerNameError('Max username length is ' + 64);
    //     return false;
    // }
    setUsername(username)
    return true
  }

  const handleLink = (event) => {
    const link = event.target.value
    setLink(link)
    return true
  }

  const handleInsta = (event) => {
    const insta = event.target.value
    setInsta(insta)
    return true
  }

  const handleTweet = (event) => {
    const tweet = event.target.value
    setTweet(tweet)
    return true
  }

  const handleDescription = (event) => {
    const description = event.target.value
    //todo:
    // if (description.length > 255) {
    //     setOwnerNameError('Max description length is ' + 255);
    //     return false;
    // }
    setDescription(description)
    return true
  }

  return (
    <div className={styles.page}>
      <Control className={styles.control} item={breadcrumbs}/>
      <div className={cn('section-pt80', styles.section)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.top}>
            <h1 className={cn('h2', styles.title)}>Edit profile</h1>
            <div className={styles.info}>
              You can set preferred display name, create{' '}
              <strong>your profile URL</strong> and manage other personal
              settings.
            </div>
          </div>
          {isConnected && !isCorrectNetwork && <SwitchNetwork/>}
          {!isConnected && <Connect/>}
          {isConnected && isCorrectNetwork &&
            <div className={styles.row}>
              <div className={styles.col}>
                <div className={styles.user}>
                  <div className={styles.avatar}>
                    <img src={avatar} alt="Avatar"/>
                  </div>
                  <div className={styles.details}>
                    <div className={styles.stage}>Profile photo</div>
                    <div className={styles.text}>
                      We recommend an image of at least 400x400. Gifs work too{' '}
                      <span role="img" aria-label="hooray">🙌</span>
                    </div>
                    <div className={styles.file}>
                      <Upload
                        listType="picture"
                        beforeUpload={handleUploadAvatar}
                        maxCount={1}
                        showUploadList={false}
                      >
                        <Button>Upload</Button>
                      </Upload>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.col}>
                <div className={styles.list}>
                  <div className={styles.item}>
                    <div className={styles.category}>Account info</div>
                    <div className={styles.fieldset}>
                      <TextInput
                        className={styles.field}
                        label="display name"
                        name="Name"
                        type="text"
                        placeholder="Enter your display name"
                        required
                        value={username}
                        onChange={handleUsername}
                      />
                      <TextInput
                        className={styles.field}
                        label="Custom url"
                        name="Url"
                        type="text"
                        placeholder={'https://' + process.env.REACT_APP_TITLE + '.com/profile/YOUR_NAME'}
                        required
                        value={link}
                        onChange={handleLink}
                      />
                      <TextInput
                        className={styles.field}
                        label="Instagram url (optional)"
                        name="InstagramUrl"
                        type="text"
                        placeholder={'https://www.instagram.com/'}
                        value={insta}
                        onChange={handleInsta}
                      />
                      <TextInput
                        className={styles.field}
                        label="Twitter url (optional)"
                        name="TwitterUrl"
                        type="text"
                        placeholder={'https://twitter.com/'}
                        value={tweet}
                        onChange={handleTweet}
                      />
                      <TextArea
                        className={styles.field}
                        label="Bio"
                        value={description}
                        name="Bio"
                        placeholder="About yourself in a few words"
                        required="required"
                        onChange={handleDescription}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.note}>
                  To update your settings you should sign message through your
                  wallet. Click 'Update profile' then sign the message
                </div>
                <div className={styles.btns}>
                  <button className={cn('button', styles.button)} onClick={updateProfile}>
                    {showLoader && <Loader className={styles.loader}/>}
                    <span>Update Profile</span>
                  </button>
                  <button className={styles.clear}>
                    <Icon name="circle-close" size="24"/>
                    Clear all
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
};